const LOGIN_USER = 'LOGIN_USER'
const SOA_LOGIN = 'SOA_LOGIN'
const BASEDATA = 'BASEDATA_'
const MENUDATA = 'MENUDATA'
const PRIVDATA = 'PRIVDATA'
const PATHS = 'PATHS'
const ORGNAME = 'ORGNAME'

export default {
  setLoginUser (user) {
    if (typeof (user) === 'object') {
      window.localStorage.setItem(LOGIN_USER, JSON.stringify(user))
    } else {
      window.localStorage.setItem(LOGIN_USER, '')
    }
  },
  getLoginUser () {
    let jsonstr = window.localStorage.getItem(LOGIN_USER)
    if (jsonstr && jsonstr !== '') {
      try {
        return JSON.parse(jsonstr)
      } catch (e) {
        console.error(e)
        return null
      }
    }
    return null
  },
  getBaseData (system) {
    let jsonstr = window.localStorage.getItem(BASEDATA + system)
    if (jsonstr && jsonstr !== '') {
      try {
        return JSON.parse(jsonstr)
      } catch (e) {
        console.error(e)
        return null
      }
    }
    return null
  },
  setBaseData (system, data) {
    window.localStorage.setItem(BASEDATA + system, JSON.stringify(data))
  },
  setMenuData (data) {
    window.localStorage.setItem(MENUDATA, JSON.stringify(data))
  },
  getMenuData () {
    let jsonstr = window.localStorage.getItem(MENUDATA)
    if (jsonstr && jsonstr !== '') {
      try {
        return JSON.parse(jsonstr)
      } catch (e) {
        console.error(e)
        return null
      }
    }
    return null
  },
  setPrivData (data) {
    window.localStorage.setItem(PRIVDATA, JSON.stringify(data))
  },
  getPrivData () {
    let jsonstr = window.localStorage.getItem(PRIVDATA)
    if (jsonstr && jsonstr !== '') {
      try {
        return JSON.parse(jsonstr)
      } catch (e) {
        console.error(e)
        return ''
      }
    }
    return ''
  },
  setPaths (data) {
    window.localStorage.setItem(PATHS, JSON.stringify(data))
  },
  getPaths () {
    let jsonstr = window.localStorage.getItem(PATHS)
    if (jsonstr && jsonstr !== '') {
      try {
        return JSON.parse(jsonstr)
      } catch (e) {
        console.error(e)
        return null
      }
    }
    return null
  },
  setOrgName (data) {
    window.localStorage.setItem(ORGNAME, data)
  },
  getOrgName () {
    return window.localStorage.getItem(ORGNAME)
  }
}



// WEBPACK FOOTER //
// ./src/utils/session.js